import React from 'react';
import AuthorizationFormIndex from '../../feature/authorization';

type AuthorizationPageProps = {
  token: string;
}

export default function AuthorizationPage(props: AuthorizationPageProps) {
  const { token } = props;
  return (
    <AuthorizationFormIndex
      token={token}
    />
  );
}
